module.exports = __webpack_public_path__ + "img/pro_eight_6.1132a14d.jpg";